import { cn } from "../foundations/cn.js";
import { useImageFallback } from "../foundations/useImageFallback.js";
import { ArtPlaceholder } from "./ArtPlaceholder.js";

export interface BoxArtProps {
  src: string;
  /** The box's name; empty when the name is already written beside it. */
  alt: string;
  /** Floats it on a stage: the art shadow and a slight tilt. */
  floating?: boolean;
  priority?: boolean;
  className?: string;
}

/**
 * A box's own artwork, contained. On a stage it floats, tilted, over a soft shadow. Missing or
 * failed to load, a pack's silhouette takes its place (`ArtPlaceholder`), named as the art was.
 */
export function BoxArt({ src, alt, floating = false, priority = false, className }: BoxArtProps) {
  const { failed, onError } = useImageFallback(src);
  if (failed) return <ArtPlaceholder kind="box" label={alt} className={className} />;
  return (
    <img
      src={src}
      alt={alt}
      onError={onError}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      className={cn(
        "block h-full w-full object-contain",
        floating && "-rotate-3 drop-shadow-[0_32px_40px_color-mix(in_oklab,black_55%,transparent)]",
        className,
      )}
    />
  );
}
